module.exports = __webpack_public_path__ + "img/pe.pe38abe80.svg";